import { useCallback, useEffect, useState } from 'react';
import PageTemplate from 'components/template/PageTemplate';
import Container from 'components/common/Container';
import { jsonAxios } from 'components/axios';
import { ISpecialData } from 'types/special';
import useCheckCompany from 'hook/useCheckCompany';
import Card from 'components/special/Card';
import CustomSelect from 'components/common/CustomSelect';
import { specialFilterSelect } from 'data/special';
import { useGetUser, userAtom } from 'atom/user';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import { encrypt } from 'components/encryptDecrpt';

const SpecialList = () => {
    const user = useGetUser();
    const setUser = useSetAtom(userAtom)
    const navigate = useNavigate();

    const [list, setList] = useState<ISpecialData[]>([]);
    const [sort, setSort] = useState<string>('')
    useCheckCompany();

    const init = useCallback(() => {
        jsonAxios.get(`special-rates?sort=${sort}`).then(res => {
            if (res.data.code === 200) {
                setList(res.data.data)
            }
        })
    }, [sort])

    useEffect(() => {
        if (user.id === undefined) return;
        jsonAxios.get('user/info').then(res => {
            if (res.data.code === 200) {
                const serUser = res.data.data
                setUser(encrypt(JSON.stringify(res.data.data)))
                if (serUser.isVIP) {
                    init();
                    return
                }
                else {
                    toast.error('해당 메뉴 이용 권한이 없습니다. 자세한 내용은 1:1 문의 주시기 바랍니다.')
                    navigate('/', { replace: true })
                    return;
                }
            }
        })
    }, [user.id, init]);

    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <Container className="flex flex-col gap-6 tablet:gap-4 mb-6 tablet:py-4 pt-21 h-ful min-h-dvh">
                <div className='flex justify-between items-center gap-4'>
                    <p className='font-semibold tablet:text-lg text-3xl'>특가운임</p>
                    <CustomSelect
                        width='w-60'
                        fontSize={14}
                        isFull={false}
                        option={specialFilterSelect}
                        placeholder='순서설정'
                        onChange={(value) => {
                            setSort(value)
                        }}
                    />
                </div>

                {

                    list.length > 0 ?
                        <div className='tablet:flex tablet:flex-col gap-6 grid grid-cols-[repeat(auto-fill,_minmax(400px,_1fr))]'>
                            {
                                list.map((item, idx) => (
                                    <Card item={item} idx={idx} key={idx} />
                                ))
                            }
                        </div> :
                        <div className='flex justify-center items-center w-full h-96'>
                            특가운임 데이터가 없습니다.
                        </div>
                }
            </Container>
        </PageTemplate>
    )
}

export default SpecialList